import React from "react";

export const MenuIcon = ({ width = 24, height = 24, color = "#000" }) => (
    <svg width={`${width}px`} height={`${height}px`} strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path d="M3 5H21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M3 12H21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M3 19H21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>)